import React, { useEffect, useState } from "react";
import "./portfolio.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import img from "../../interior_assets/porfolio/IMG1.jpeg";
import img1 from "../../interior_assets/porfolio/IMG2.jpeg";
import img2 from "../../interior_assets/porfolio/IMG3.jpeg";
import img3 from "../../interior_assets/porfolio/IMG4.jpeg";
import img4 from "../../interior_assets/porfolio/download (1).jpg";
import img5 from "../../interior_assets/porfolio/download (2).jpg";
import img6 from "../../interior_assets/porfolio/download.jpg";
import luxury1 from "../../interior_assets/Interior Website Images/Living Hall Design/Luxury Design 1.jpeg";
import modern1 from "../../interior_assets/Interior Website Images/Living Hall Design/Modern Design 1.jpeg";
import warm1 from "../../interior_assets/Interior Website Images/Living Hall Design/Warm Living Spaces 1.jpg";
import Green1 from "../../interior_assets/Interior Website Images/Balcony Design/Green Garden Seatout Balcony 1.jpg";
import small1 from "../../interior_assets/Interior Website Images/Balcony Design/Small & Space-Saving Balcony 1.jpg";
import cozy1 from "../../interior_assets/Interior Website Images/Balcony Design/Cozy Balcony With Seating Nook 1.jpg";
import Lshape1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/L- Shaped Kitchen 1.jpg";
import Ushape1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/U- Shaped Kitchen 1.jpg";
import straight1 from "../../interior_assets/Interior Website Images/Modular Kitchen Design/Straight Kitchen 1.jpg";
import luxurydesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Luxury Dining Hall 1.jpg";
import normaldesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Normal Dining Hall 1.jpg";
import Traditionaldesign1 from "../../interior_assets/Interior Website Images/Dining Hall Design/Traditional Dining Hall 1.jpg";
import mordernmaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Modern Master Bedroom 1.jpg";
import luxurymaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Luxury Master Bedroom 1.jpg";
import Normalmaster1 from "../../interior_assets/Interior Website Images/Master Bedroom Design/Normal Master Bedroom 1.jpg";
import Mwardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 1.jpg";
import slidewardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Sliding Wardrobe Design 1.jpg";
import hingedwardrobe1 from "../../interior_assets/Interior Website Images/Wardrobe Design/Hinged Door Wardrobe 1.jpg";
import Mordernbath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Modern Bathroom 1.jpg";
import compactbath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Compact Small Space Bathroom 1.jpg";
import luxurybath1 from "../../interior_assets/Interior Website Images/Bathroom Design/Luxury Spa - Style Bathroom 1.jpg";
import ledtv1 from "../../interior_assets/Interior Website Images/TV Unit Design/LED Backlit TV Unit 1.jpg";
import stonetv1 from "../../interior_assets/Interior Website Images/TV Unit Design/Marble Or Stone Finish Tv Unit 1.jpg";
import walltv1 from "../../interior_assets/Interior Website Images/TV Unit Design/Wall - Mounted TV Unit 1.jpg";
import studykid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Study - Focused Kids Room 1.jpg";
import interactivekid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Interactive Kids Room With Activity Zone 1.jpg";
import themedkid1 from "../../interior_assets/Interior Website Images/Kids Room Design/Themed Kids Room 1.jpg";
import poojadesign1 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Pooja Mandir Design 1.jpg"
import islamicdesign1 from "../../interior_assets/Interior Website Images/Prayer Hall Design/Islamic Prayer Hall Design 1.jpeg"
import luxuryfalse from "../../interior_assets/Interior Website Images/False Ceiling Design/Luxury False Ceiling.jpg";
import officearea from "../../interior_assets/Interior Website Images/False Ceiling Design/Office Area False Ceiling Design.jpg";
import showroomsfalse from "../../interior_assets/Interior Website Images/False Ceiling Design/Showroom False Ceiling.jpg";
import Granite from "../../interior_assets/Interior Website Images/Flooring gesign/Granite Flooring.jpeg"
import Marble from "../../interior_assets/Interior Website Images/Flooring gesign/Marble Flooring.jpeg"
import Terrazzo from "../../interior_assets/Interior Website Images/Flooring gesign/Terrazzo Flooring.jpeg"
import titlesflooring from "../../interior_assets/Interior Website Images/Flooring gesign/Tiles Flooring.jpeg"
import vinyl from "../../interior_assets/Interior Website Images/Flooring gesign/Vinyl Flooring.jpeg"
import wooden from "../../interior_assets/Interior Website Images/Flooring gesign/Wooden Flooring.jpeg"
import automobile3 from "../../interior_assets/Interior Website Images/Showroom Design/automobile3.jpeg"
import cosmatic3 from "../../interior_assets/Interior Website Images/Showroom Design/showroom images (3).jpg"
import modernfabric1 from "../../interior_assets/Interior Website Images/Showroom Design/modernfabric1.jpeg"
import Matte from "../../interior_assets/Interior Website Images/Wall Paint Design/Matte Finish Paint.jpeg";
import Satin from "../../interior_assets/Interior Website Images/Wall Paint Design/Satin &Eggshell Finish Paint.jpeg";
import Texturedpaint from "../../interior_assets/Interior Website Images/Wall Paint Design/Textured Paint.jpeg";
import ReCAPTCHA from "react-google-recaptcha";

// Design categories with images
const categories = [
  {
    name: "Living Hall Design",
    des: "Create the perfect living hall with designs that reflect your style and elevate your home.",
    images: [
      { src: modern1, title: "Modern Design" },
      { src: luxury1, title: "Luxury Design" },
      { src: warm1, title: "Warm Living Space Design" }
    ]
  },
  {
    name: "Modular Kitchen Design",
    des: "Maximize functionality and style with tailored kitchen layouts designed to suit your space.",
    images: [
      { src: straight1, title: "Straight Kitchen" },
      { src: Lshape1, title: "L-Shaped Kitchen" },
      { src: Ushape1, title: "U-Shaped Kitchen" }
    ]
  },
  {
    name: "Dining Hall Design",
    des: "Create a dining space that suits your lifestyle, whether it's luxurious, casual, or traditional.",
    images: [
      { src: normaldesign1, title: "Normal Dining Hall" },
      { src: luxurydesign1, title: "Luxury Dining Hall" },
      { src: Traditionaldesign1, title: "Traditional Dining Hall" }
    ]
  },
  {
    name: "Master Bedroom Design",
    des: "Design your sanctuary with a master bedroom that reflects your taste and offers ultimate comfort.",
    images: [
      { src: mordernmaster1, title: "Modern Master Bedroom" },
      { src: luxurymaster1, title: "Luxury Master Bedroom" },
      { src: Normalmaster1, title: "Normal Master Bedroom" }
    ]
  },
  {
    name: "Wardrobe Design",
    des: "Tailored wardrobe solutions that blend functionality with style to fit your space.",
    images: [
      { src: Mwardrobe1, title: "Modular Wardrobe" },
      { src: slidewardrobe1, title: "Sliding Door Wardrobe" },
      { src: hingedwardrobe1, title: "Hinged Door Wardrobe" }
    ]
  },
  {
    name: "Bathroom Design",
    des: "Transform your bathroom into a functional and stylish retreat.",
    images: [
      { src: Mordernbath1, title: "Modern Bathroom" },
      { src: luxurybath1, title: "Luxury Spa-Style Bathroom" },
      { src: compactbath1, title: "Compact Small-Space Bathroom" }
    ]
  },
  {
    name: "Balcony Design",
    des: "Create a perfect outdoor space with designs that match your lifestyle.",
    images: [
      { src: Green1, title: "Green Garden Sit-out Balcony" },
      { src: small1, title: "Small & Space-Saving Balcony" },
      { src: cozy1, title: "Cozy Balcony with Seating Nook" }
    ]
  },
  {
    name: "TV Unit Design",
    des: "Stylish and functional designs to enhance your living room.",
    images: [
      { src: walltv1, title: "Wall-Mounted TV Unit" },
      { src: ledtv1, title: "LED Backlit TV Unit" },
      { src: stonetv1, title: "Marble or Stone Finish TV Unit" }
    ]
  },
  {
    name: "Kids Room Design",
    des: "Create a fun, functional, and inspiring space for your child",
    images: [
      { src: studykid1, title: "Study-Focused Kids' Room" },
      { src: themedkid1, title: "Themed Kids' Room" },
      { src: interactivekid1, title: "Interactive Kids’ Room with Activity Zone" }
    ]
  },
  {
    name: "Prayer Hall Design",
    des: "Create a serene and sacred space for worship and reflection.",
    images: [
      { src: poojadesign1, title: "Pooja Mandir Design" },
      { src: islamicdesign1, title: "Islamic Prayer Hall" }
    ]
  },
  {
    name: "False Ceiling Design",
    des: "Enhance your space with stylish, functional false ceiling solutions.",
    images: [
      { src: luxuryfalse, title: "Commercial Luxury False Ceiling" },
      { src: showroomsfalse, title: "Showrooms False Ceiling" },
      { src: officearea, title: "Office Area False Ceiling" }
    ]
  },
  {
    name: "Wall Paint Design",
    des: "Transform your walls with a range of paint finishes to suit every space and style.",
    images: [
      { src: Texturedpaint, title: "Textured Paint" },
      { src: Matte, title: "Matte Finish Paint" },
      { src: Satin, title: "Satin & Eggshell Finish Paint" },
      { src: img4, title: "Glossy & Semi-Gloss Paint" },
      { src: img5, title: "Metallic Wall Paint" },
      { src: img6, title: "Marble Finish Wall Paint" },
      { src: img, title: "Venetian Plaster" },
      { src: img1, title: "Stencil Wall Paint" }
    ]
  },
  {
    name: "Flooring Design",
    des: "Choose the perfect flooring to enhance the beauty and functionality of your space.",
    images: [
      { src: Marble, title: "Marble Flooring" },
      { src: Granite, title: "Granite Flooring" },
      { src: wooden, title: "Wooden Flooring" },
      { src: titlesflooring, title: "Tile Flooring" },
      { src: vinyl, title: "Vinyl Flooring" },
      { src: Terrazzo, title: "Terrazzo Flooring" },
      // { src: concre, title: "Concrete Flooring" },
      // { src: car, title: "Carpet Flooring" }
    ]
  },
  {
    name: "Showroom Design",
    des: "Create a striking and functional showroom that enhances your brand and attracts customers",
    images: [
      { src: cosmatic3, title: "Compact Cosmetic Showroom" },
      { src: modernfabric1, title: "Modern Fabric Showroom" },
      { src: automobile3, title: "Automobile Showroom" }
    ]
  }
];
function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [imageIndex, setImageIndex] = useState(0);
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    designName: "",
    modelname: "",
  });

  const navigate = useNavigate();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const[loading, setLoading] = useState(false);



  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set to true when CAPTCHA is verified
    } else {
      setCaptchaVerified(false); // Set to false if not verified
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setImageIndex(0);
  };

  const handleNextButtons = () => {
    if (visibleIndex + 8 < categories.length) {
      setVisibleIndex((prev) => prev + 1);
    }
  };

  const handlePrevButtons = () => {
    if (visibleIndex > 0) {
      setVisibleIndex((prev) => prev - 1);
    }
  };

  const handleNextImage = () => {
    if (imageIndex + 3 < selectedCategory.images.length) {
      setImageIndex((prev) => prev + 1);
    }
  };

  const handlePrevImage = () => {
    if (imageIndex > 0) {
      setImageIndex((prev) => prev - 1);
    }
  };

  const handleTitleClick = (category, title) => {
    navigate(`/portfoliopage/${category.name}/${title}`);

    window.scrollTo(0, 0);
  };


  // Open the form with optional design name
  const handleOpenForm = (designname = "", modelname = "") => {
    setFormData((prev) => ({
      ...prev,
      modelname: modelname,
      designname: designname,
    }));
    setShowForm(true);
  };

  // Close the form
  const handleCloseForm = () => {
    setShowForm(false);
    setFormData({ name: "", email: "", phone: "", location: "", designName: "" });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure all required fields are filled
    if (!formData.name || !formData.email || !formData.phone || !formData.location || !formData.designname || !formData.modelname) {
      alert("Please fill in all required fields.");
      return;
    }
    if (!captchaVerified) {
      setErrors("Please verify that you are not a robot.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://demo.firstskyinfra.in/php/model.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "success") {
        // alert("Enquiry submitted successfully!");
        navigate('/thank_you')
        setFormData({ name: "", email: "", phone: "", location: "", designname: "", modelname: "" }); // Reset form
        handleCloseForm(); // Close the form
      } else {
        alert(`Failed to submit enquiry: ${data.message || "Please try again."}`);
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("An error occurred. Please try again later.");
    }finally{
      setLoading(false);
    }
  };

  return (
    <section style={{ marginTop: "50px" }}>
      <div className="design-details">
        <h3>Design Ideas for Every Space</h3>
        <p>Because every corner holds a unique design potential.</p>
      </div>

      {/* Sliding Buttons */}
      <div className="button-slider">
        <button className="slider-nav" onClick={handlePrevButtons} disabled={visibleIndex === 0}>
          <FaChevronLeft />
        </button>

        <div className="design-button">
          {categories.slice(visibleIndex, visibleIndex + 8).map((category) => (
            <button
              key={category.name}
              className={category.name === selectedCategory.name ? "active" : ""}
              onClick={() => handleCategoryChange(category)}
            >
              {category.name}
            </button>
          ))}
        </div>

        <button className="slider-nav" onClick={handleNextButtons} disabled={visibleIndex + 8 >= categories.length}>
          <FaChevronRight />
        </button>
      </div>

      {/* Image Display */}
      <div className="image-container-image">
        <div className="container display-container">
          <h4>{selectedCategory.name}</h4>
          <p>{selectedCategory.des}</p>
        </div>

        <div className="image-wrapper-view">
          {selectedCategory.images.slice(imageIndex, imageIndex + 3).map((img, idx) => (
            <div key={idx} className="image-div-container-view">
              <img src={img.src} alt={img.title} className="selected-image-view" />
              <div className="image-overlay">
                <span className="image-text clickable" onClick={() => handleTitleClick(selectedCategory, img.title)}>
                  {img.title}
                </span>
                <button className="enquire-button" onClick={() => handleOpenForm(img.title, selectedCategory.name)}>Get Enquiry</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Enquiry Form Popup */}
      {showForm && (
        <div className="form-popup">
          <div className="form-container">
            <h3 style={{ textAlign: "center" }}>Contact Us</h3>
            <form>
              <div className="input-row">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder=" "
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                  <label>Name</label>
                </div>
                <div className="input-group">
                  <input
                    type="email"
                    placeholder=" "
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                  />
                  <label>Email</label>
                </div>
              </div>

              <div className="input-row">
                <div className="input-group">
                  <input
                    type="tel"
                    placeholder=" "
                    value={formData.phone}
                    onChange={(e) => {
                      // Ensure only numbers are entered and limit to 10 digits
                      const phoneNumber = e.target.value.replace(/\D/, "").slice(0, 10);
                      setFormData({ ...formData, phone: phoneNumber });
                    }}
                    maxLength="10"
                    required
                  />
                  <label>Phone Number</label>
                  {/* {errors.phone && <span className="error">{errors.phone}</span>} */}
                </div>

                <div className="input-group">
                  <select
                    value={formData.location}
                    onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                    required
                  >
                    <option value="" disabled>Select City</option>
                    <option value="Chennai">Chennai</option>
                    <option value="Hyderabad"> Hyderabad</option>
                    <option value="Kerela">Kerela</option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>

                  </select>
                  <label>Location</label>
                </div>
              </div>

              <div className="input-row">
                <div className="input-group">
                  <input type="text" placeholder=" " name="designname" value={formData.modelname} disabled />
                  <label>Design Name</label>
                </div>
                <div className="input-group">
                  <input type="text" placeholder=" " name="modelname" value={formData.designname} disabled />
                  <label>Model Name</label>
                </div>
              </div>
              <div className="input-row">
                <ReCAPTCHA
                  sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
                  // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
                  // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                  //  // Replace with your reCAPTCHA site key
                  onChange={handleCaptchaChange}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <button type="submit" className="submit-button" onClick={handleSubmit}
              disabled={loading}>
                {loading ? "Sending..." : "Submit"}</button>
                <button className="close-button" onClick={handleCloseForm}>close</button>
              </div>



            </form>
          </div>
        </div>
      )}

    </section>
  );
}

export default Portfolio;